import { cn } from '@/lib/utils';

const CLASS: Record<string, string> = {
  draft: 'bg-bone text-forest/70',
  active: 'bg-forest/10 text-forest',
  sold: 'bg-forest-100 text-forest-800',
  removed: 'bg-red-50 text-red-700',
};

const LABEL: Record<string, string> = {
  draft: 'Draft',
  active: 'Published',
  sold: 'Sold',
  removed: 'Removed',
};

export function ItemStatusBadge({ status }: { status: string }) {
  return (
    <span className={cn('inline-block rounded px-2 py-0.5 text-xs font-medium', CLASS[status] ?? 'bg-slate-100 text-slate-600')}>
      {LABEL[status] ?? status}
    </span>
  );
}
